import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Obtiene la URL base para archivos estáticos
 * @returns La URL estática configurada o window.location.origin como fallback
 */
export const getStaticUrl = (): string => {
  return import.meta.env.VITE_STATIC_URL || window.location.origin;
};

/**
 * Construye una URL completa para un archivo estático
 * @param path - Ruta relativa del archivo (ej: '/maps/layers/jalisco.json')
 * @returns URL completa del archivo estático
 */
export const getStaticFileUrl = (path: string): string => {
  if (path.startsWith('http')) {
    return path;
  }
  const staticUrl = getStaticUrl();
  return `${staticUrl}${path}`;
}; 